import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { list } from "../../../controllers/V1/userRequest/userRequestController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatProjectDate } from "../../../controllers/common";

const Export = ({ popUpOpen, togglePopUp, defaultFilter = {} }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      const search = formData.get("search") || "";
      const status = formData.get("status") || "";
      const from_date = formData.get("from_date") || "";
      const to_date = formData.get("to_date") || "";

      const option = {
        isExport: true,
        condition: {
          ...(status ? { status } : null),
          ...(from_date ? { createdAt: { $gte: from_date, $lte: to_date || new Date() } } : null),
          ...(search
            ? {
                $or: [
                  { first_name: { $regex: search, $options: "i" } },
                  { last_name: { $regex: search, $options: "i" } },
                  { store_name: { $regex: search, $options: "i" } },
                ],
              }
            : null),
        },
        sort: { _id: -1 },
      };

      const res = await list(option);
      if (res.status === true && res.result?.length > 0) {
        const modifiedData = res.result.map((item) => ({
          "First Name": item.first_name || "",
          "Last Name": item.last_name || "",
          Mobile: item.mobile ? `${item.country_code || ""}${item.mobile}` : "",
          Email: item.email || "",
          "Store Name": item.store_name || "",
          Area: item.area || "",
          Address: item.address || "",
          "BDM Status": item.bdm_status || "",
          "Deploy Status": item.deployment_status || "",
          Status: item.status || "",
          "POS Number": item.pos_number || "",
          "Refer By": item.referBy || "",
          "Trade License No": item.trade_license_no || "",
          "Created Date": item.createdAt
            ? moment(formatProjectDate(item.createdAt)).format("DD-MM-YYYY hh:mm A")
            : "",
        }));
        await exportToExcel(modifiedData);
        handleCancel();
      } else {
        setError("No records found matching the criteria.");
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", err);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "User Requests");
      XLSX.writeFile(workbook, `Crown King User Requests ${moment().format("YYYY-MM-DD")}.xlsx`);
    } catch (err) {
      alert("Error generating Excel file: " + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth
      maxWidth="md"
      PaperProps={{ className: "myDialogPopUp" }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export User Requests
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="search" className="all_lable_for_vendor_dashbaord">Search (Name / Store):</label>
                    <input
                      type="text"
                      name="search"
                      id="search"
                      defaultValue={defaultFilter.search || ""}
                      placeholder="Search..."
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="status" className="all_lable_for_vendor_dashbaord">Status:</label>
                    <select name="status" id="status" defaultValue={defaultFilter.status || ""} className="form-control categories_select_tg_enter_product">
                      <option value="">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Completed">Completed</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label className="all_lable_for_vendor_dashbaord">Date range (optional):</label>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="from_date" className="all_lable_for_vendor_dashbaord">From:</label>
                    <input
                      type="datetime-local"
                      name="from_date"
                      id="from_date"
                      defaultValue={defaultFilter.from_date || ""}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="to_date" className="all_lable_for_vendor_dashbaord">To:</label>
                    <input
                      type="datetime-local"
                      name="to_date"
                      id="to_date"
                      defaultValue={defaultFilter.to_date || ""}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: "red", padding: "0 16px 16px" }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text="Preparing download..." />
    </Dialog>
  );
};

export default Export;
